// Material-UI
import { Typography } from "@mui/material";

// Icons
import GreenCheck from "@/Auth/assets/icons/greencheck.svg";
import GreyDot from "@/Auth/assets/icons/greydot.svg";

const MIN_CHARACTERS = 8;

const passwordValidationHints = [
	{ hint: `Must be at least ${MIN_CHARACTERS} characters long`, check: (password: string) => password.length >= MIN_CHARACTERS },
	{ hint: "Contains at least 1 number", check: (password: string) => /\d/.test(password) },
	{ hint: "Contains at least 1 uppercase letter", check: (password: string) => /[A-Z]/.test(password) },
	{ hint: "Contains 1 lowercase letter", check: (password: string) => /[a-z]/.test(password) },
	{ hint: "Contains 1 special character", check: (password: string) => /[^\da-zA-Z]/.test(password) },
];

export function PasswordValidationHints({ password }: Readonly<{ password: string }>) {
	return (
		<>
			{passwordValidationHints.map((hint, index) => {
				const key = `hint-${index}`;
				return (
					<Typography key={key} className="!text-[14px]/[24px] !text-[color:--text-color]">
						{hint.check(password) ? (
							<img className="inline-block relative bottom-[2px] mr-[5px]" src={GreenCheck} alt="Green check indicator" />
						) : (
							<img
								className="inline-block relative left-[6px] bottom-[2px] mr-[15px]"
								src={GreyDot}
								alt="Gray dot indicator"
							/>
						)}
						{hint.hint}
					</Typography>
				);
			})}
		</>
	);
}
